var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00016,
    cy: 3.99992,
    r: 2.66667,
    fill: "#43474F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 11.6667C13.3332 13.3236 13.3332 14.6667 7.99984 14.6667C2.6665 14.6667 2.6665 13.3236 2.6665 11.6667C2.6665 10.0099 5.05432 8.66675 7.99984 8.66675C10.9454 8.66675 13.3332 10.0099 13.3332 11.6667Z",
    fill: "#43474F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.30c4326bfa354890fb9971ddb8e0e95a.svg";
export { ForwardRef as ReactComponent };